import userRoutes from './routes';
import usersSlice from './store/users.store';
import UserSearchInput from './containers/Search/UserSearchContainer';
export { userRoutes };

const moduleConfig = {
  routes: userRoutes,
  reducers: {
    users: usersSlice.reducer,
  },
};

export { UserSearchInput };

export default moduleConfig;
